import type { Period, ProgressResult } from '../domain/progress.ts';
import { failure, validPeriod } from '../domain/progress.ts';
import type { NutritionRepository } from '../ports/nutrition-repository.ts';
import type { NutritionProgressFacts, NutritionProgressSource } from '../ports/progress-sources.ts';
export class PublicNutritionProgress implements NutritionProgressSource {
  constructor(private repository: Pick<NutritionRepository, 'readContext' | 'listPlannedMeals' | 'readMealResolutions' | 'listConsumptions'>) {}
  async readNutritionFacts(period: Period): Promise<ProgressResult<NutritionProgressFacts>> {
    if (!validPeriod(period)) return failure('VALIDATION_ERROR');
    const context = await this.repository.readContext(); if (!context.ok) return context;
    const plans = await this.repository.listPlannedMeals(period.startLocalDate, period.endLocalDate); if (!plans.ok) return plans;
    const results = await this.repository.readMealResolutions(plans.value.map(p => p.meal.plannedMealId)); if (!results.ok) return results;
    const actual = await this.repository.listConsumptions(period.startLocalDate, period.endLocalDate); if (!actual.ok) return actual;
    const after = await this.repository.readContext(); if (!after.ok) return after;
    if (after.value.datasetId !== context.value.datasetId || after.value.controlEpoch !== context.value.controlEpoch
      || plans.value.some(p=>p.context.datasetId !== context.value.datasetId || p.context.controlEpoch !== context.value.controlEpoch)) return failure('DATASET_STALE');
    const statuses = new Map(results.value.map(c => [c.plannedMealId, c.resolution]));
    const quantitative = actual.value
      .filter(c => c.resolution === 'REALIZADA')
      .flatMap(c => c.contents.map(entry => ({
        consumptionId: c.consumptionId,
        consumptionRevision: c.revision,
        localDate: c.localDate,
        ...(c.plannedMealId ? { plannedMealId: c.plannedMealId } : {}),
        entry: structuredClone(entry),
      })));
    return { ok: true, value: { plans: plans.value.map(p => p.meal), actual: actual.value,
      quantitative,
      resolutions: plans.value.map(p => ({ plannedMealId: p.meal.plannedMealId, localDate: p.meal.localDate,
        status: statuses.get(p.meal.plannedMealId) ?? 'SIN_REGISTRAR' })) } };
  }
}
